import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Employee} from './employees';

@Injectable()
export class EmployeeService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('employees?' + params.toString()).map((response: Response) => response.json());
    }
    getAllCities() {
        return this.http.get('all/cities').map((response: Response) => response.json());
    }
    getAllBranches() {
        return this.http.get('branches/all').map((response: Response) => response.json());
    }
    getAllJobs() {
        return this.http.get('jobs/all').map((response: Response) => response.json());
    }
    getAllOrgs() {
        return this.http.get('orgs/all').map((response: Response) => response.json());
    }

    deletePic(_id: string) {
        return this.http.put('emp/picture/delete/' + _id,{}).map((response: Response) => response.json());
    }
    deletePic1(_id: string) {
        return this.http.put('org/picture/delete1/' + _id,{}).map((response: Response) => response.json());
    }
    getAllCurrencies() {
        return this.http.get('all/currencies').map((response: Response) => response.json());
    }
    getLogo() {
        return this.http.get('employees/logo').map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('employees/' + _id).map((response: Response) => response.json());
    }


    getTrashedById(_id: string) {
        return this.http.get('employees/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('employees/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(employee: Employee) {
        return this.http.post('employees', employee).map((response: Response) => response.json());
    }

    update(employee: Employee) {
        return this.http.put('employees/' + employee.id, employee).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('employees/' + _id);
    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/employees/employees.service.ts